import React, { lazy } from 'react'
import { useEffect } from 'react';
import { Route, Routes , useLocation} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
const Home = lazy(()=>import("./Home"));
const Explore = lazy(()=>import("./Explore"));
const Saved = lazy(()=>import("./Saved"));
const Myrecbie = lazy(()=>import("./Myrecbie"));


export default function Pages() {
  const location= useLocation();

  useEffect(() => {
    
    if(location.pathname.includes("explore")) {
    document.getElementById('explore').classList.add('active')
    } else {
      document.getElementById('explore').classList.remove('active')
    }
  }, [location.pathname])
  
  return (
    <AnimatePresence>
    <Routes location={location} key={location.key}>
      <Route path="/" element={<Home />} />
      <Route  path="/explore/:type" element={<Explore />} />
      <Route path="/myrecbie" element={<Myrecbie />} />
      <Route path="/saved" element={<Saved/>} />
    </Routes>
    </AnimatePresence>
  );
}
